import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function CTA() {
  return <section className="py-24 relative overflow-hidden bg-dark" data-id="element-12">
      <div className="absolute inset-0 bg-stadium-gradient opacity-50 pointer-events-none" data-id="element-13" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-64 bg-neon-magenta/10 blur-[100px] pointer-events-none" data-id="element-14" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-15">
        <div className="max-w-3xl mx-auto text-center bg-dark-card/50 backdrop-blur-md border border-white/10 p-12 rounded-3xl" data-id="element-16">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-rajdhani text-4xl md:text-6xl font-bold mb-6" data-id="element-17">
            READY TO LEVEL UP YOUR{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-magenta to-neon-cyan" data-id="element-18">
              SPONSORSHIP GAME?
            </span>
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-gray-400 text-lg mb-10" data-id="element-19">
            Join hundreds of teams and brands already closing deals on
            Pixelkeep. Early access spots are limited.
          </motion.p>

          <motion.form initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto" onSubmit={e => e.preventDefault()} data-id="element-20">
            <input type="email" placeholder="Enter your email address" className="flex-1 bg-dark border border-white/20 rounded-md px-6 py-4 text-white focus:outline-none focus:border-neon-cyan focus:ring-1 focus:ring-neon-cyan transition-all" required data-id="element-21" />
            <button type="submit" className="px-8 py-4 bg-neon-cyan text-dark font-bold rounded-md shadow-[0_0_15px_rgba(0,243,255,0.3)] hover:shadow-[0_0_25px_rgba(0,243,255,0.6)] transition-all flex items-center justify-center gap-2 whitespace-nowrap" data-id="element-22">
              Join the Waitlist
              <ArrowRight className="w-5 h-5" data-id="element-23" />
            </button>
          </motion.form>
        </div>
      </div>
    </section>;
}